import styled, { css } from 'styled-components';
import { navTheme } from '../../../theme/nav-theme';
export const GlobalToolbarDivider = styled.div.withConfig({
  displayName: "GlobalToolbarDivider",
  componentId: "k9a7ax-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["height:24px;width:1px;background:", ";content:'';margin:0 5px 0 11px !important;"], navTheme(theme).navBorderPrimary);
});